module.exports = __webpack_public_path__ + "img/2-3.dfa50f1c.svg";